import styled from '@emotion/styled';
import { FONT, SPACING } from '../../styles/emotion';
import COLORS3, { COLORS_GRAYS } from '../../styles/emotion/colors3';
import MEDIA_QUERY, { SCREEN_MASSIVE } from '../../styles/emotion/mediaQuery';

const borderStyling = `1px solid ${COLORS_GRAYS.BLACK_030}`;

export const Container = styled.footer`
  background: ${COLORS3.CLOUD_100};
  border-left: ${borderStyling};
  border-right: ${borderStyling};
  border-top: ${borderStyling};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: ${SCREEN_MASSIVE}px;
  width: 100%;

  @media (max-width: ${SCREEN_MASSIVE - 1}px) {
    border-left: none;
    border-right: none;
  }
`;

export const ContentWrapper = styled.div`
  border-bottom: ${borderStyling};
  display: flex;
  justify-content: flex-start;
  width: 100%;

  ${MEDIA_QUERY.MOBILE_XS} {
    flex-direction: column-reverse;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    justify-content: space-between;
  }
`;

export const LinksSectionWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const ZolaIdentityWrapper = styled.div`
  border-left: ${borderStyling};
  padding: 60px ${SPACING.LG};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    padding: 60px ${SPACING.MD};
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    border-bottom: ${borderStyling};
    border-left: none;
    margin: 0 ${SPACING.MD};
    padding: 60px 0;
  }
`;

export const LinksSectionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LinksSectionListItem = styled.li`
  margin: 0 0 9px;
`;

export const LinksSectionTitle = styled.h5`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${FONT.FONT_SIZE_REGULAR};
  margin-bottom: ${SPACING.S24};
  letter-spacing: normal;
`;

export const ZolaSignature = styled.h5`
  margin: ${SPACING.S24} 0 ${SPACING.LG};
  font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  font-size: ${FONT.FONT_SIZE_REGULAR};
  letter-spacing: normal;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALL};
    margin-bottom: ${SPACING.S24};
  }
`;

export const LinksSectionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 60px ${SPACING.LG};
  width: 66.66%;

  ${MEDIA_QUERY.MOBILE} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    grid-template-columns: 1fr 1fr;
    padding: 60px ${SPACING.MD};
    width: 50%;
  }
`;
